// !!!! - DO NOT MODIFY - !!!!
// THIS FILE IS DEPLOYED AUTOMATICALLY BY MATTv2.
//
//  Deployment info:
//    Updated at:     2026-05-12T12:07:28+00:00
//    Cause:          Manual deployment.
//    Deployment ID:  192125
//    Project:        617
//    Environment:    7626 - master
//    MD5:            fc19f8218ee423d48502dad6c3ac2595
//    Signature:      eyJpdiI6IkZRczJFQlVKbWQ3RUpwc05lQzBTMGc9PSIsInZhbHVlIjoiR2lvbCtNK3htK3lKQXp3QWg5dGJWR2xYTnkyVDRLaUp4c2tcL2tSVkprS01MdktjXC9xK1NROHFEcXhQVURmNW80MlRYRkRqa2g0ZjQ4Q2lBUnF3ZmNLNGlGYWVOaTVmeW9RN0ZyTHpLSXdvK1UzVnpSYmlUQkpVWDltR1ZLdTUzVEVZSkZGWW5oTnBReVFyMW5aZ21UU3docVdJVHVGSWRlR0w0cmpJODM2WnpQd0pOU29kY1JRK3BoZkxabE9NTlp4bE9IdGNvUTZjSDYrYm5iSlI5MnE3OE1lT2ozd2kzUFU2c003SWdaTG5rbG5cLzI4UE1BRnVWcTYwc2IrUHZNTzI3NGthMm9OOWpBTkFFQzFMd0txZGVIeVF0d3RlY3d5dnlMSWszaGpZZnlGZVBBTGo0emN0T0dxNndwUnh4a3FZQjNNVTZzbSthTUs2enRvNys0TXJpQXJZQ3pRYzVKYWVkNm1NeU9vNWhxVW5zVG9ySWE1YXJaeU85bEJLbSs1clA3MmdVZWcrRG5NNUg5WFREb2NFN1VYdGw1bGorcEhRVThJRWVGUExsbz0iLCJtYWMiOiI3M2VkYjI2MGU5NWQyNDQ4YzU5NjNlYzUyYTgzZDJkNzU5NzRkNGNmYzhlYWZhODljODIwMGUwZGI2YThkNjk0In0=
const termsCheckbox = document.getElementById('terms');
const subscribeButton = document.getElementById('Subscribe');

if (termsCheckbox && subscribeButton) {
termsCheckbox.addEventListener('change', function() {
  subscribeButton.disabled = !this.checked;
});
}